let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:9090';
} else if (hostname === 'cormier.thewebpeople.ca') {
    backendHost = 'https://custom.thewebpeople.ca';
} else {
    backendHost = 'https://custom.thewebpeople.ca';
}

export const API_ROOT = `${backendHost}/api`;